/**
 * Utility functions for handling media URLs and embedding
 */
/**
 * Transforms URLs to make them embeddable
 * Particularly useful for Google Drive and other external sources
 */
export const getEmbedUrl = (url: string): string => {
  // Handle Google Drive file URLs
  if (url.includes('drive.google.com/file/d/')) {
    // Extract the file ID from the URL
    const fileIdMatch = url.match(/\/d\/([^/]+)/)
    if (fileIdMatch && fileIdMatch[1]) {
      const fileId = fileIdMatch[1]
      return `https://drive.google.com/file/d/${fileId}/preview`
    }
  }
  // Handle Google Drive document URLs
  if (url.includes('docs.google.com/document')) {
    return url.replace('/edit', '/preview').replace('/view', '/preview')
  }
  // Handle Google Drive presentation URLs
  if (url.includes('docs.google.com/presentation')) {
    return url.replace('/edit', '/preview').replace('/view', '/preview')
  }
  // Handle YouTube URLs
  if (url.includes('youtube.com/watch') || url.includes('youtu.be/')) {
    let videoId
    if (url.includes('youtube.com/watch')) {
      const urlParams = new URLSearchParams(url.split('?')[1])
      videoId = urlParams.get('v')
    } else {
      videoId = url.split('/').pop()
    }
    if (videoId) {
      return `https://www.youtube.com/embed/${videoId}`
    }
  }
  // Return the original URL if no transformation is needed
  return url
}
/**
 * Extracts direct audio file URL from Google Drive for streaming
 * Note: This provides a URL format that works for embedding but may require authentication
 */
export const getAudioStreamUrl = (url: string): string => {
  // Handle Google Drive file URLs for audio
  if (url.includes('drive.google.com/file/d/')) {
    const fileIdMatch = url.match(/\/d\/([^/]+)/)
    if (fileIdMatch && fileIdMatch[1]) {
      const fileId = fileIdMatch[1]
      // Direct streaming URL format
      return `https://docs.google.com/uc?export=open&id=${fileId}`
    }
  }
  return url
}
